/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFileRevisionResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type FileRevisionResponse, type HttpValidationProblemDetails, type IError } from '../../../../models/index.js';
// @ts-ignore
import { AbortRequestBuilderRequestsMetadata, type AbortRequestBuilder } from './abort/index.js';
// @ts-ignore
import { ArchiveRequestBuilderRequestsMetadata, type ArchiveRequestBuilder } from './archive/index.js';
// @ts-ignore
import { CommentsRequestBuilderNavigationMetadata, CommentsRequestBuilderRequestsMetadata, type CommentsRequestBuilder } from './comments/index.js';
// @ts-ignore
import { CompleteRequestBuilderRequestsMetadata, type CompleteRequestBuilder } from './complete/index.js';
// @ts-ignore
import { CopyToFileRequestBuilderRequestsMetadata, type CopyToFileRequestBuilder } from './copyToFile/index.js';
// @ts-ignore
import { DownloadRequestBuilderRequestsMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { EditRequestBuilderNavigationMetadata, type EditRequestBuilder } from './edit/index.js';
// @ts-ignore
import { NoteRequestBuilderRequestsMetadata, type NoteRequestBuilder } from './note/index.js';
// @ts-ignore
import { PreviewsRequestBuilderRequestsMetadata, type PreviewsRequestBuilder } from './previews/index.js';
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { SharesRequestBuilderNavigationMetadata, SharesRequestBuilderRequestsMetadata, type SharesRequestBuilder } from './shares/index.js';
// @ts-ignore
import { type UploadRequestBuilder, UploadRequestBuilderNavigationMetadata } from './upload/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}
 */
export interface WithRevisionItemRequestBuilder extends BaseRequestBuilder<WithRevisionItemRequestBuilder> {
    /**
     * The abort property
     */
    get abort(): AbortRequestBuilder;
    /**
     * The archive property
     */
    get archive(): ArchiveRequestBuilder;
    /**
     * The comments property
     */
    get comments(): CommentsRequestBuilder;
    /**
     * The complete property
     */
    get complete(): CompleteRequestBuilder;
    /**
     * The copyToFile property
     */
    get copyToFile(): CopyToFileRequestBuilder;
    /**
     * The download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * The edit property
     */
    get edit(): EditRequestBuilder;
    /**
     * The note property
     */
    get note(): NoteRequestBuilder;
    /**
     * The previews property
     */
    get previews(): PreviewsRequestBuilder;
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
    /**
     * The shares property
     */
    get shares(): SharesRequestBuilder;
    /**
     * The upload property
     */
    get upload(): UploadRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FileRevisionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FileRevisionResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithRevisionItemRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithRevisionItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithRevisionItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    abort: {
        requestsMetadata: AbortRequestBuilderRequestsMetadata,
    },
    archive: {
        requestsMetadata: ArchiveRequestBuilderRequestsMetadata,
    },
    comments: {
        requestsMetadata: CommentsRequestBuilderRequestsMetadata,
        navigationMetadata: CommentsRequestBuilderNavigationMetadata,
    },
    complete: {
        requestsMetadata: CompleteRequestBuilderRequestsMetadata,
    },
    copyToFile: {
        requestsMetadata: CopyToFileRequestBuilderRequestsMetadata,
    },
    download: {
        requestsMetadata: DownloadRequestBuilderRequestsMetadata,
    },
    edit: {
        navigationMetadata: EditRequestBuilderNavigationMetadata,
    },
    note: {
        requestsMetadata: NoteRequestBuilderRequestsMetadata,
    },
    previews: {
        requestsMetadata: PreviewsRequestBuilderRequestsMetadata,
    },
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
    shares: {
        requestsMetadata: SharesRequestBuilderRequestsMetadata,
        navigationMetadata: SharesRequestBuilderNavigationMetadata,
    },
    upload: {
        navigationMetadata: UploadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithRevisionItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithRevisionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, application/problem+json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: WithRevisionItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFileRevisionResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
